import moment from 'moment';

const DATE_FORMAT = 'YYYY-MM-DD';

moment.fn.dayDiff = function dayDiff(other) {
    return moment(this.format(DATE_FORMAT)).diff(moment(other.format(DATE_FORMAT)), 'days');
};
